import { ENV } from '@/environment/client';

export const HYPERLIQUID_NETWORK = ENV.NEXT_PUBLIC_HYPERLIQUID_NETWORK;
export const IS_HYPERLIQUID_TESTNET = HYPERLIQUID_NETWORK === 'testnet';

export const HYPERLIQUID_API_URL = IS_HYPERLIQUID_TESTNET
  ? 'https://api.hyperliquid-testnet.xyz'
  : 'https://api.hyperliquid.xyz';

/** 0x Cross-Chain quotes HyperCore perps USDC (USDC_PERP) with 8 decimals. */
export const HYPERCORE_PERPS_USDC_DECIMALS = 8;

/** Spot token index of USDC; perp dexs collateralized in anything else are hidden. */
export const USDC_TOKEN_INDEX = 0;
/** Hyperliquid rejects orders below this notional. */
export const PERPS_MIN_ORDER_NOTIONAL_USD = 10;
/** Market orders are IOC limits priced this far through the mark. */
export const PERPS_MARKET_SLIPPAGE = 0.05;
/** Market TP/SL fill this far past the trigger, matching Hyperliquid's own frontend. */
export const PERPS_TRIGGER_SLIPPAGE = 0.1;
export const PERPS_RECENT_TRADES_LIMIT = 500;
export const PERPS_RECENT_FILLS_LIMIT = 500;

export const BUILDER_ADDRESS = ENV.NEXT_PUBLIC_HYPERLIQUID_BUILDER_ADDRESS;
/** Builder fee in tenths of a basis point: 50 = 5 bps = 0.05%. */
export const BUILDER_FEE_TENTHS_BPS = 50;
export const BUILDER_FEE_RATE = BUILDER_FEE_TENTHS_BPS / 100_000;
/** Most the user approves us to charge, in the same unit as Hyperliquid's `maxBuilderFee`. */
export const BUILDER_MAX_FEE_TENTHS_BPS = 50;
export const BUILDER_MAX_FEE_RATE = `${BUILDER_MAX_FEE_TENTHS_BPS / 1000}%`;
/** Owned by the builder account; set on users with no referrer (they get a 4% fee discount). */
export const REFERRAL_CODE = 'MATCHA';

/**
 * Tier-0 perps rates (https://hyperliquid.gitbook.io/hyperliquid-docs/trading/fees), shown
 * until a wallet is connected and `userFees` can report the user's own tier.
 */
export const HYPERLIQUID_BASE_PERP_FEES = {
  takerRate: 0.00045,
  makerRate: 0.00015,
  referralDiscount: 0,
};

/** Stable name so each re-approval replaces the previous Matcha agent instead of adding one. */
export const AGENT_NAME = 'Matcha';
/** Rotate the browser-held agent key after this long. */
export const AGENT_VALIDITY_MS = 180 * 24 * 60 * 60 * 1000;
/** Re-approve when the agent has less than this left, so a session never expires mid-trade. */
export const AGENT_EXPIRY_BUFFER_MS = 24 * 60 * 60 * 1000;
